import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { DocumentDownload } from 'iconsax-react';
export const SecondaryDownloadButton = ({ disabled = false, loading = false, onClick }) => {
    const theme = useTheme();
    const isDisabled = disabled || loading;
    const color = disabled ? '#FDBCBC' : theme.palette.primary.main;
    return (_jsxs(Box, { component: 'button', type: 'button', disabled: isDisabled, "aria-busy": loading, onClick: onClick, sx: {
            width: '100%',
            height: '50px',
            px: '25px',
            borderRadius: '25px',
            border: `1px solid ${color}`,
            backgroundColor: '#FFFFFF',
            color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            cursor: loading ? 'progress' : disabled ? 'not-allowed' : 'pointer',
            transition: 'background-color 150ms ease',
            '&:hover': {
                backgroundColor: isDisabled ? '#FFFFFF' : 'rgba(236, 14, 110, 0.08)'
            },
            '&:active': {
                backgroundColor: isDisabled ? '#FFFFFF' : 'rgba(236, 14, 110, 0.08)'
            },
            '&:focus-visible': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: '2px'
            }
        }, children: [loading ? (_jsx(CircularProgress, { size: 18, thickness: 4, sx: { color: theme.palette.primary.main } })) : (_jsx(DocumentDownload, { size: 20, color: color, variant: 'Linear' })), _jsx(Typography, { variant: 'subtitle2', sx: { color, fontWeight: 500, whiteSpace: 'nowrap' }, children: loading ? 'Generating PDF…' : 'Download timesheet PDF' })] }));
};
